<template>
  <div id="app">
    <el-container>
      <el-header class="div-header">
        <Header />
        <el-divider class="header-divider"></el-divider>
      </el-header>

      <div class="main-div SID1016">
        <el-container class="main-div parentDiv">
          <splitpanes class="default-theme defaultStyle custom-splite">
            <pane size="100" class="SideBarLeft">
              <!--SID1016 Body Part-->
              <template>
                <el-container class="SID1016__infoRegistration">
                  <div class="SID1016__Container">
                    <!-- Breadcrumb section -->
                    <el-breadcrumb separator-class="el-icon-arrow-right customStyle">
                      <el-breadcrumb-item :to="{ path: '0002' }">トップ(記事一覧)</el-breadcrumb-item>
                      <el-breadcrumb-item :to="{ path: '' }">トピックス情報一覧</el-breadcrumb-item>
                    </el-breadcrumb>
                    <!-- Breadcrumb section Ended -->
                    <el-container>
                      <el-tabs v-model="getactivename" >
                        <el-tab-pane label="新規作成・編集" name="first">
                          <div class="ButtonDiv">
                            <el-button type="primary" plain @click="save()">追加</el-button>
                            <el-button type="danger" @click="deleteTopics" plain>削除</el-button>
                          </div>

                          <div>
                            <el-table
                              border
                              ref="multipleTable"
                              :data="getFirstTabResult1016"
                              style="width: 100%"
                              @selection-change="handleSelectionChange"
                              class="first_table"
                            >
                              <el-table-column type="selection"   width="60"></el-table-column>
                              <el-table-column label="編集" fixed="left" width="100">
                                <!-- HS removed primary from type -->
                                <template slot-scope="scope">
                                <el-button type="primary" plain @click="editpage(scope.row)">編集</el-button>
                                </template>
                              </el-table-column>
                              <el-table-column prop="display_order" label="表示順" min-width="100"></el-table-column>
                              <el-table-column prop="topics_id" label="トピックスID" min-width="120"></el-table-column>

                              <el-table-column
                                prop="topics_name"
                                label="トピックスタイトル"
                                min-width="350"
                              ></el-table-column>
                              <el-table-column prop="theme_count" label="テーマ数" min-width="auto"></el-table-column>
                            </el-table>
                          </div>

                          <div class="ButtonDivTable">
                            <el-button type="primary" plain @click="save()">追加</el-button>
                            <el-button type="danger" plain @click="deleteTopics">削除</el-button>
                            <span class="buttonSpan">{{ text }}</span>
                          </div>
                        </el-tab-pane>
                        <el-tab-pane label="表示順指定" name="second">
                          <div class="secondTab">
                            <span>テーマグループをドラッグして表示順を設定してください</span>
                          </div>
                          <div class="ButtonDivTable">
                            <el-button type="primary" @click="dragTableClick()" plain>保存</el-button>
                          </div>
                          <div>
                            <el-table-draggable>
                              <el-table
                                border
                                ref="orderTable"
                                :data="getTableResult1016"
                                style="width: 100%"
                                class="secondtableClass"
                              >
                                <el-table-column label width="90">
                                  <img
                                    class="table-img"
                                    src="../../assets/image/two_lines-svg-new.svg"
                                    alt="LOGO"
                                  />
                                </el-table-column>
                                <el-table-column
                                  prop=""
                                  type="index"
                                  label="表示順"
                                  width="265"
                                ></el-table-column>
                                <el-table-column prop="topics_id" label="トピックスID" min-width="120"></el-table-column>

                                <el-table-column
                                  prop="topics_name"
                                  label="トピックスタイトル"
                                  min-width="auto"
                                ></el-table-column>
                                <el-table-column prop="theme_count" label="テーマ数" min-width="auto"></el-table-column>
                              </el-table>
                            </el-table-draggable>
                          </div>
                          <div class="BottomButtonDivTable">
                            <el-button
                              class="setMarginTop"
                              type="primary"
                              style
                              plain
                              @click="dragTableClick()"
                            >保存</el-button>
                            <span class="buttonSpan">{{ dummy }}</span>
                          </div>
                        </el-tab-pane>
                      </el-tabs>
                    </el-container>
                  </div>
                </el-container>
              </template>
              <!--SID1016 Body Part End-->
            </pane>
            <pane class="SideBarRight">
              <SideBar class="SidePane" />
            </pane>
          </splitpanes>
        </el-container>
      </div>

      <el-container class="footer-div">
        <el-footer class="footer-element">
          <FooterComponent />
        </el-footer>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import Header from "../common/header.vue";
import SideBar from "../common/side-bar.vue";
import FooterComponent from "../common/footerComponent.vue";
import { mapGetters } from "vuex";
import ElTableDraggable from "element-ui-el-table-draggable";
import router from "../../router";
import json from "../../components/config.json";
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";
import common_json from "../../common/CommonConst.json";
const newArr = {};
export default {
  name: "1016",
  components: {
    Header,
    SideBar,
    FooterComponent,
    Splitpanes,
    Pane,
    ElTableDraggable
  },
  data() {
    return {
      multipleSelection: [],
      text: "",
      dummy: ""
    };
  },
  methods: {
    save() {
this.$LogButtonEvent("1016","AddTo");
this.$LogMethodIN("1016","save");
      router.push({ name: "1017" });
      this.$LogMethodOut("1016","save");
    },
    editpage(row) {
this.$LogButtonEvent("1016","Edit");
this.$LogMethodIN("1016","editpage");
      var Details = {
        topics_id: row.topics_id,
        topics_name: row.topics_name,

      };
      var edit_data = {
				contract_id : '0001',
				topics_id : row.topics_id
			}
		this.$store.dispatch('communication1017/EditFormDetails_1017',edit_data).then(() => {
        router.push({name: "1017",params: {Details: Details} });
      
    });
    this.$LogMethodOut("1016","editpage");
    },
    //To get the checked checkbox
    handleSelectionChange(val) {
this.$LogButtonEvent("1016","ChangeSelection");
this.$LogMethodIN("1016","handleSelectionChange");
      newArr.value = val;
      
this.$LogMethodOut("1016","handleSelectionChange");
    },
    // when checkbox is checked and get the length
    // Pass parameters topics_id, topics_check to the tableDelete function to the communication1016
    deleteTopics() {
this.$LogButtonEvent("1016","Delete");
this.$LogMethodIN("1016","deleteTopics");
      var tableContent_final=[];
		if (this.$refs.multipleTable.selection.length > 0) {
        this.$confirm(
          json["1016_delete_confirm_message"],
          json["1016_delete_confirm_message_title"],
          {
            showCancelButton: true,
            confirmButtonText: "OK",
            cancelButtonText: "キャンセル"
           
          }
        ).then(() => {
			var arraySelection = this.$refs.multipleTable.selection;
      var tableArray = this.$refs.multipleTable.tableData;
      
      
      for(var i=0;i< tableArray.length; i++){
        var tabledata_inner = {};
        tabledata_inner.topics_id = this.getTpoicsIdResult1016[i];
        tabledata_inner.topics_check = 0;

        for(var k=0;k<arraySelection.length;k++){
          if(tableArray[i].topics_id == arraySelection[k].topics_id){
              tabledata_inner.topics_check = 1;
              
          }
        }
         tableContent_final.push(tabledata_inner);
        }
        var deleteDetails = {
        contract_id: common_json["contract_id"],
        "topics_info":tableContent_final

        };
        this.$store.dispatch("communication1016_1/tableDelete", deleteDetails).then(() => {
						//After the Ajax call finished check if status is error for showing alert
						var status = this.getstatus;
						var msgdetail = this.getmsgdetail;
						if(status == "0")
						{
							this.$alert(msgdetail, json["1016_delete_success_title"], {	confirmButtonText: 'OK'})	
						}
						else if(status == "1")
						{
							this.$alert(msgdetail, json["1016_delete_failed_title"] , {	confirmButtonText: 'OK'})
						}
					})
					.catch((error) => { 
            console.log(error);
						this.$alert(this.getmsgdetail, json["1016_delete_failed_title"], {	confirmButtonText: 'OK'	});
					});
        });
      } else {
        this.$alert(
          json["1016_checkbox_not_check_message"],
          json["1016_checkbox_not_check_message_title"],
          {
            confirmButtonText: "OK"
          }
        );
      }
    this.$LogMethodOut("1016","deleteTopics");
    },
    // table data's draggable and change the display order 
    // Pass parameters topics_id, display_order
    // update the display_order to  the table
    dragTableClick() {
this.$LogButtonEvent("1016","Save");
this.$LogMethodIN("1016","dragTableClick");
      var tableLoop = this.$refs.orderTable.tableData.length;
      var tableContent=[];
      for(var i=0;i<tableLoop;i++){
        var tableContent1={};
        tableContent1.topics_id=this.$refs.orderTable.tableData[i].topics_id;
        tableContent1.display_order=this.getdisplayOrderResult1016[i];
        tableContent.push(tableContent1);
      }
      var draggableOrderList ={
        contract_id:this.getContractId, 
        topics_info:tableContent

      };
     this.$store.dispatch("communication1016_1/draggableOrder",draggableOrderList);
      this.$alert(
        json["1016_2_success_message"],
        json["1016_2_success_title"],
        {
          confirmButtonText: "OK"
        });
        this.$LogMethodOut("1016","dragTableClick");
    }
    
  },

  computed: {
    ...mapGetters("situation1016", [
      "getTableResult1016",
      "getcheck",
      "getactivename",
      "getdisplayOrderResult1016"
     
    ]),
    ...mapGetters("situation1016_1", [
      "getFirstTabResult1016",
      "getTpoicsIdResult1016",
      "getstatus",
      "getmsgdetail"
    ]),
    ...mapGetters("situation0001", [
			"getContractId"
			
		])
  },
  mounted() {
    this.$store.dispatch("communication1016/getSecondTableData");
    this.$store.dispatch("communication1016_1/getTableData_first");
    this.$store.dispatch("communication1016_1/getSampleTableData");
  },
  beforeCreate(){
		//Common.Session.CheckSessionExists_IfExpired_GoToLogout();
  },
  created(){
    //For the screen Title
     document.title = "トピックス情報一覧画面";
    
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "1016.css";
</style>